export enum ContainerMaxWidth {
  Small = 540,
  Medium = 720,
  Large = 960,
  ExtraLarge = 1140,
}
